// МОДУЛИ БЕЗ ВНЕШНИХ ЗАВИСИМОСТЕЙ
// Эти модули начнут загружаться сразу параллельно с jQuery
const independentModules = [
    () => import(/* webpackChunkName: "form" */ "@partials/UI/form/form.js"),
    () => import(/* webpackChunkName: "click-outside" */ "@scripts/modules/click-outside.js"),
    () => import(/* webpackChunkName: "langs" */ "@partials/UI/langs/langs.js"),
    () => import(/* webpackChunkName: "button-consult" */ "@partials/UI/button/button-consult.js"),
    () => import(/* webpackChunkName: "sticky" */ "@scripts/modules/sticky.js"),
    () => import(/* webpackChunkName: "anchors" */ "@scripts/modules/anchors.js"),
    () => import(/* webpackChunkName: "mobile-menu" */ "@partials/UI/mobile-menu/mobile-menu.js"),
    () => import(/* webpackChunkName: "feedback-widget" */ "@partials/UI/feedback/widget/widget.js"),
    () => import(/* webpackChunkName: "feedback-modal" */ "@partials/UI/feedback/modal/modal.js"),
    () => import(/* webpackChunkName: "notifications" */ "@partials/UI/notifications/notifications.js"),
];

// МОДУЛИ, ТРЕБУЮЩИЕ JQUERY
// Эти модули загрузятся только после того, как jQuery будет готов
const jQueryDependentModules = [
    Object.assign(
        () => import(/* webpackChunkName: "accordion" */ "@partials/UI/accordion/accordion.js"),
        { requiresExternal: true }
    ),
];

// Объединяем все модули
const commonModules = [
    ...independentModules,
    ...jQueryDependentModules
];

// Внешние ресурсы (jQuery)
const commonExternalResources = [
    {
        name: "jquery",
        type: "script",
        url: "https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js",
    }
];

export {
    commonModules,
    commonExternalResources
};